const path = "/rh/data-distribuicao";
export default { main: path };
